import { render, staticRenderFns } from "./PagedReportPanel.vue?vue&type=template&id=2daf39ad&"
import script from "./PagedReportPanel.vue?vue&type=script&lang=js&"
export * from "./PagedReportPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports